import React, {useEffect, useState} from "react";
import VriContainer from "./vri/VriContainer";
import AcContainer from "./app-center/AcContainer";
import {getPreferredACPaymentMethod, getPreferredVDSPaymentMethod, handleError} from "../../helpers/helpers";
import {loadSettings} from "../../api/requests";
import {ServerResponse} from "../../models/models";
import {RESPONSE_TYPES, SUBSCRIPTION_ROOT_PAGES, VDS_LEVEL, VRI_LEVEL} from "../../constants";
import Loading from "../common/Loading";
import ResponseCard from "../common/cards/ResponseCard";
import VdsContainer from "./vds/VdsContainer";
import HomeContainer from "./home/HomeContainer";
import SubscriptionsContainerDataRefreshManager from "./SubscriptionsContainerDataRefreshManager";

const SubscriptionsContainer = () => {
    const [serverResponse, setServerResponse] = useState(new ServerResponse());
    const [loading, setLoading] = useState(true);
    const [appCenterData, setAppCenterData] = useState(null);
    const [vriData, setVriData] = useState(null);
    const [vdsData, setVdsData] = useState(null);
    const [settings, setSettings] = useState(null);
    const [rootPage, setRootPage] = useState(SUBSCRIPTION_ROOT_PAGES.HOME);

    const [shouldRefresh, setShouldRefresh] = useState(false);

    const {allPaymentMethods} = appCenterData || {};
    const [preferredACPaymentMethod, setPreferredACPaymentMethod] = useState(getPreferredACPaymentMethod(allPaymentMethods));
    const [preferredVDSPaymentMethod, setPreferredVDSPaymentMethod] = useState(getPreferredVDSPaymentMethod(allPaymentMethods));
    const [preferredVRIPaymentMethod, setPreferredVRIPaymentMethod] = useState(getPreferredVDSPaymentMethod(allPaymentMethods));

    if (serverResponse.type !== RESPONSE_TYPES.none) {
        return (
            <ResponseCard response={serverResponse}/>
        );
    }

    const hasVriSubscription = vriData?.level !== VRI_LEVEL.NONE;
    const hasVdsSubscription = vdsData?.level !== VDS_LEVEL.NONE;

    let developerLevel = 0;
    let settingsRole = 0;
    if (appCenterData) {
        const {devLevel} = appCenterData;
        developerLevel = devLevel;
    }
    if (settings) {
        const {role} = settings;
        settingsRole = role;
    }

    // developer Level of 1 is SERVER role of 1 is RESELLER
    if (developerLevel === 1 && settingsRole === 1) {
        return (
            <div>
                <Loading show={loading}/>
                <SubscriptionsContainerDataRefreshManager
                    shouldRefresh={shouldRefresh}
                    setSettings={setSettings}
                    setAppCenterData={setAppCenterData}
                    setPreferredACPaymentMethod={setPreferredACPaymentMethod}
                    setPreferredVDSPaymentMethod={setPreferredVDSPaymentMethod}
                    setPreferredVRIPaymentMethod={setPreferredVRIPaymentMethod}
                    setVriData={setVriData}
                    setVdsData={setVdsData}
                    setLoading={setLoading}/>
                <AcContainer data={appCenterData}
                             setData={setAppCenterData}
                             settings={settings}
                             handleError={handleError}
                             setRootPage={setRootPage}
                             rootPage={SUBSCRIPTION_ROOT_PAGES.AC}
                             hasVriSubscription={hasVriSubscription}
                             setServerResponse={setServerResponse}
                             setShouldRefresh={setShouldRefresh}
                             preferredACPaymentMethod={preferredACPaymentMethod}/>
            </div>
        );
    }

    return (
        <div data-testid={'subscriptionsContainer'}>
            <Loading show={loading}/>
            <SubscriptionsContainerDataRefreshManager
                shouldRefresh={shouldRefresh}
                setSettings={setSettings}
                setAppCenterData={setAppCenterData}
                setPreferredACPaymentMethod={setPreferredACPaymentMethod}
                setPreferredVDSPaymentMethod={setPreferredVDSPaymentMethod}
                setPreferredVRIPaymentMethod={setPreferredVRIPaymentMethod}
                setVriData={setVriData}
                setVdsData={setVdsData}
                setLoading={setLoading}/>

            <div className={'row'}>
                <div className={'col-12'}>
                    <HomeContainer rootPage={rootPage}
                                   appCenterData={appCenterData}
                                   vriData={vriData}
                                   vdsData={vdsData}
                                   setRootPage={setRootPage}
                                   settings={settings}/>

                    <AcContainer data={appCenterData}
                                 setData={setAppCenterData}
                                 rootPage={rootPage}
                                 settings={settings}
                                 setRootPage={setRootPage}
                                 setServerResponse={setServerResponse}
                                 setShouldRefresh={setShouldRefresh}
                                 preferredACPaymentMethod={preferredACPaymentMethod}
                                 handleError={handleError}/>
                    <VriContainer
                        appData={appCenterData}
                        data={vriData}
                        setData={setVriData}
                        settings={settings}
                        rootPage={rootPage}
                        handleError={handleError}
                        setRootPage={setRootPage}
                        setServerResponse={setServerResponse}
                        setShouldRefresh={setShouldRefresh}
                        preferredVRIPaymentMethod={preferredVRIPaymentMethod}/>
                    <VdsContainer
                        appData={appCenterData}
                        data={vdsData}
                        setData={setVdsData}
                        settings={settings}
                        rootPage={rootPage}
                        handleError={handleError}
                        setRootPage={setRootPage}
                        setServerResponse={setServerResponse}
                        setShouldRefresh={setShouldRefresh}
                        preferredVDSPaymentMethod={preferredVDSPaymentMethod}/>
                </div>
            </div>
        </div>
    );
}

export default SubscriptionsContainer;